import { mpesaTransaction, gpt } from '../actions/types';
import RestClient from '../../api/axiosInterceptor';

// fetch user data
export const fetchUserData = () => {
  return async (dispatch) => {
    dispatch({ type: user.FETCH_USER_REQUEST });
    try {
      const response = await RestClient.get('/auth/user-detail');
      dispatch({ type: user.FETCH_USER_SUCCESS, payload: response.data });
    } catch (error) {
      dispatch({ type: user.FETCH_USER_FAILURE, error: error.message });
    }
  };
};

// user logout
export const logoutUser = () => {
  return async (dispatch) => {
    try {
      await RestClient.post('/auth/logout', {});
      dispatch({ type: user.LOGOUT_SUCCESS });
      // window.location.href = '/'; // Redirect to homepage or login page
    } catch (error) {
      console.error('Logout failed', error);
      // Optionally, show a notification to the user
    }
  };
};

// update user data
export const updateUserData = (userData) => {
  return async (dispatch) => {
    dispatch({ type: user.UPDATE_USER_REQUEST });

    try {
      const response = await RestClient.put('/auth/user-detail', userData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      dispatch({ type: user.UPDATE_USER_SUCCESS, payload: response.data });
    } catch (error) {
      dispatch({ type: user.UPDATE_USER_FAILURE, error: error.message });
    }
  };
};

// gpt
export const fetchGptResponse = (query) => {
  return async (dispatch) => {
    dispatch({ type: gpt.FETCH_GPT_REQUEST });
    dispatch({ type: gpt.FETCH_GPT_LOADING });

    try {
      const response = await RestClient.post('/asst/gpt/', { query });
      const jsonResponse = response.data;

      dispatch({ type: gpt.FETCH_GPT_SUCCESS, payload: jsonResponse });
    } catch (error) {
      dispatch({ type: gpt.FETCH_GPT_FAILURE, error: error.message });
    }
  };
};

// generate stk push / create a transaction
export const postSTKPush = (transactionData) => {
  return async (dispatch) => {
    dispatch({ type: mpesaTransaction.POST_MPESA_TRANSACTION_FAILURE });
    try {
      const response = await RestClient.post(
        '/generate-stk-push',
        transactionData
      );
      dispatch({
        type: mpesaTransaction.POST_MPESA_TRANSACTION_SUCCESS,
        payload: response.data
      });
    } catch (error) {
      dispatch({
        type: mpesaTransaction.POST_MPESA_TRANSACTION_FAILURE,
        error: error.message
      });
    }
  };
};
